import create, { SetState, GetState } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

import {
  CreatePropertyAdSlice,
  CreatePropertyAdSliceFields,
} from './CreatePropertyAdSlice'
import { authSlice, AuthSlice } from './AuthSlice'
import { drawerSlice, DrawerSliceStore } from './DrawerSlice'

export type StoreSlice<T extends object, E extends object = T> = (
  set: SetState<E extends T ? E : E & T>,
  get: GetState<E extends T ? E : E & T>
) => T

export const useCreatePropertyAdStore = create(
  devtools(
    (
      set: SetState<CreatePropertyAdSliceFields>,
      get: GetState<CreatePropertyAdSliceFields>
    ) => ({
      ...CreatePropertyAdSlice(set, get),
    }),
    { name: 'createPropertyAd' }
  )
)

export const useDrawerStore = create(
  devtools(
    (set: SetState<DrawerSliceStore>, get: GetState<DrawerSliceStore>) => ({
      ...drawerSlice(set, get),
    }),
    { name: 'drawer' }
  )
)

export const useAuthStore = create(
  devtools(
    persist(
      (set: SetState<AuthSlice>, get: GetState<AuthSlice>) => ({
        ...authSlice(set, get),
      }),
      {
        name: 'auth',
        getStorage: () => localStorage,
      }
    ),
    { name: 'spourgiti-admin-auth' }
  )
)
